//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters } from "vuex";
import { defaultBlockProps } from "~/helpers/data";

export default {
    name: "BowInfoImmobile",

    props: {
        ...defaultBlockProps,
    },

    data: () => ({
        ctaToSend: [],
        prezzo: null,
        prezzoLabel: null,
    }),

    fetch() {
        this.prezzo =
            this.info.prezzo && this.info.prezzo.value
                ? this.info.prezzo.value
                : null;
        this.prezzoLabel =
            this.info.prezzo && this.info.prezzo.label
                ? this.info.prezzo.label
                : null;

        if (this.cta && this.cta.length > 0) {
            this.cta.forEach((item, idx) => {
                if (idx > 1) {
                    return;
                }

                this.ctaToSend.push({
                    ...item,
                    theme: idx === 0 ? "secondary" : "primary",
                    hollow: idx === 1,
                });
            });
        }
    },

    computed: {
        ...mapState({
            info: ({ immobile }) => immobile.info,
        }),

        ...mapGetters(["immobile/getInfo"]),
    },
};
